import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiLogOut, FiSettings, FiGrid, FiArchive, FiClipboard, FiHelpCircle, FiCode, FiMenu, FiX } = FiIcons;

const navLinks = [
  { to: '/start-building', text: 'Start Building', icon: FiClipboard },
  { to: '/saved-projects', text: 'Saved Projects', icon: FiArchive },
  { to: '/categories', text: 'Categories', icon: FiGrid },
  { to: '/setup-guides', text: 'Setup Guides', icon: FiHelpCircle },
  { to: '/tool-code-extractor', text: 'Tool: Code Extractor', icon: FiCode },
  { to: '/settings', text: 'Settings', icon: FiSettings },
];

const NavItem = ({ to, text, icon, onClick }) => (
  <NavLink
    to={to}
    onClick={onClick}
    className={({ isActive }) =>
      `flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors ${
        isActive
          ? 'bg-gray-900 text-white'
          : 'text-gray-500 hover:bg-gray-700 hover:text-white'
      }`
    }
  >
    <SafeIcon icon={icon} className="mr-3 h-5 w-5" />
    {text}
  </NavLink>
);

function Header() {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('promptly_session');
    navigate('/login');
  };

  const toggleMobileMenu = () => setMobileMenuOpen(!isMobileMenuOpen);

  return (
    <header className="bg-white/80 backdrop-blur-md shadow-sm sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex-shrink-0">
            <h1 className="text-xl font-bold text-gray-800">Promptly 2.0</h1>
          </div>
          <nav className="hidden md:flex items-center space-x-4">
            {navLinks.map((link) => (
              <NavItem key={link.to} {...link} />
            ))}
            <button
              onClick={handleLogout}
              className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-gray-500 hover:bg-gray-700 hover:text-white transition-colors"
            >
              <SafeIcon icon={FiLogOut} className="mr-2 h-5 w-5" />
              Logout
            </button>
          </nav>
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none"
            >
              <SafeIcon icon={isMobileMenuOpen ? FiX : FiMenu} className="h-6 w-6" />
            </button>
          </div>
        </div>
      </div>
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden"
          >
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              {navLinks.map((link) => (
                <NavItem key={link.to} {...link} onClick={() => setMobileMenuOpen(false)} />
              ))}
              <button
                onClick={handleLogout}
                className="w-full flex items-center px-3 py-2 rounded-md text-sm font-medium text-gray-500 hover:bg-gray-700 hover:text-white transition-colors"
              >
                <SafeIcon icon={FiLogOut} className="mr-3 h-5 w-5" />
                Logout
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}

export default Header;